import { useTranslation } from "react-i18next";
import NotificationDarkIcon from "../../../assets/img/notificationDark.svg";
import CloseButton from "../../../components/Common/CloseButton";
import Modal from "../../../components/Common/Modal";
import "./notification.scss";
import NotificationCard from "./NotificationCard";
import NotificationListSkeleton from "./NotificationListSkeleton";

const NotificationModal = ({
  show,
  close,
  isLoading,
  notificationData,
  deleteNotificationOnce,
  handleNotificationClick,
  clearAllNotifications,
  canClearAll = true,
  canDelete = true,
}) => {
  const { t } = useTranslation("common");
  const list = Array.isArray(notificationData) ? notificationData : [];
  const showSkeleton = isLoading && list.length === 0;

  const handleClearAll = () => {
    if (!isLoading && list.length > 0) {
      clearAllNotifications();
    }
  };

  return (
    <Modal
      show={show}
      close={close}
      justify="right"
      containerClassName="notification-modal"
    >
      <div className="bg-white h-100">
        <div className="modal-header" style={{ borderRadius: 0 }}>
          <h6 className="modal-type d-flex align-items-center fs-22 gap-2">
            <img src={NotificationDarkIcon} loading="lazy" />
            {t("notifications.title")}
          </h6>
          <div className="d-flex align-items-center gap-3">
            {canClearAll && list.length > 0 && (
              <button
                type="button"
                style={{
                  background: "#8B0000",
                  color: "white",
                  fontSize: "14px",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontWeight: "500",
                }}
                onClick={handleClearAll}
                disabled={isLoading}
              >
                {t("notifications.clearAll")}
              </button>
            )}
            <CloseButton onClick={close} theme="dark" />
          </div>
        </div>
        <div
          className="modal-body p-3"
          style={{
            overflow: "auto",
            height: "calc(100% - 80px)",
          }}
        >
          {showSkeleton ? (
            <NotificationListSkeleton />
          ) : (
            <>
              {list.map((noti, index) => (
                <NotificationCard
                  key={noti.id}
                  notification={noti}
                  isFetching={isLoading}
                  delete={deleteNotificationOnce}
                  canDelete={canDelete}
                  handleNotificationClick={(id, read) =>
                    handleNotificationClick(id, index, read)
                  }
                />
              ))}

              {!isLoading && list.length === 0 && (
                <p className="py-4 w-100 text-center fs-16 fw-500 text-gray mb-0">
                  {t("notifications.noNotifications")}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default NotificationModal;